/**
 * ConventionOpportunityCard — Convention signing opportunity
 * MAESTRO:P1D · Relocated to vault/ for MAESTRO:P8B
 *
 * Renders convention info: name, dates, distance, creator matches
 * with signable items from vault, estimated sig cost vs value add.
 */

export default function ConventionOpportunityCard({ data }) {
  if (!data) return null;

  const { name, dates, distance, creator_matches = [], estimated_value_add } = data;

  return (
    <div
      className="bg-zinc-900 border-l-4 border-purple-500 rounded-lg p-4 my-2"
      role="region"
      aria-label={`Convention opportunity: ${name || 'event'}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-purple-500 font-bold text-xs uppercase tracking-wider">
          Convention Opportunity
        </span>
      </div>

      <h4 className="text-white font-semibold text-sm">{name}</h4>

      <div className="flex flex-wrap gap-3 mt-2 text-xs text-zinc-400">
        {dates && <span>{dates}</span>}
        {distance && <span>{distance} mi away</span>}
      </div>

      {creator_matches.length > 0 && (
        <div className="mt-3">
          <p className="text-zinc-500 text-xs mb-1">Creator Matches</p>
          <div className="flex flex-wrap gap-2">
            {creator_matches.map((match, i) => (
              <span
                key={i}
                className="bg-purple-900/30 text-purple-300 px-2 py-1 rounded text-xs"
              >
                {match.creator_name}
                {match.signable_count > 0 && (
                  <span className="ml-1 text-purple-400">
                    ({match.signable_count} items)
                  </span>
                )}
              </span>
            ))}
          </div>
        </div>
      )}

      {estimated_value_add && (
        <p className="text-green-400 text-xs mt-2">
          Est. value add: +${estimated_value_add}
        </p>
      )}
    </div>
  );
}
